function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from '../utils/classNames';

var makeTransitionStyles = function makeTransitionStyles(_ref) {
  var shouldShow = _ref.shouldShow,
      angle = _ref.angle,
      animationDuration = _ref.animationDuration,
      depth = _ref.depth;
  return {
    transition: "opacity ".concat(animationDuration, "ms ease-in"),
    opacity: shouldShow ? 1 : 0,
    transform: "rotateX(".concat(angle, "deg) translateZ(").concat(depth, "px)")
  };
};

var RotatingPanel = /*#__PURE__*/function (_PureComponent) {
  _inherits(RotatingPanel, _PureComponent);

  var _super = _createSuper(RotatingPanel);

  function RotatingPanel() {
    _classCallCheck(this, RotatingPanel);

    return _super.apply(this, arguments);
  }

  _createClass(RotatingPanel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          qa = _this$props.qa,
          ariaLive = _this$props.ariaLive,
          shouldShow = _this$props.shouldShow,
          angle = _this$props.angle,
          animationDuration = _this$props.animationDuration,
          children = _this$props.children,
          depth = _this$props.depth;
      return /*#__PURE__*/React.createElement("div", {
        ref: this.container,
        "data-qa": qa,
        "aria-live": shouldShow ? ariaLive : null,
        "aria-hidden": !shouldShow,
        style: makeTransitionStyles({
          shouldShow: shouldShow,
          animationDuration: animationDuration,
          angle: angle,
          depth: depth
        }),
        className: classNames('psw-fill-x', 'psw-top-left', 'psw-l-line-center')
      }, children);
    }
  }]);

  return RotatingPanel;
}(PureComponent);

RotatingPanel.defaultProps = {
  qa: '',
  shouldShow: false,
  angle: 90,
  animationDuration: 300,
  depth: 0,
  children: null,
  ariaLive: ''
};
RotatingPanel.propTypes = {
  qa: PropTypes.string,
  shouldShow: PropTypes.bool,
  angle: PropTypes.number,
  animationDuration: PropTypes.number,
  children: PropTypes.node,
  depth: PropTypes.number,
  ariaLive: PropTypes.oneOf(['assertive', 'polite'])
};
export default RotatingPanel;